<template>
  <CFooter :fixed="false">
    <div>
      <a target="_blank">پنل فروشگاهی  </a>
      <span class="ml-1 panel-version" :title="build">نسخه {{version}}</span>
    </div>

  </CFooter>
</template>

<script>
import { APP_VERSION, BUILD_ID } from '@/utils/version'

export default {
  name: 'TheFooter',
  data(){
    return {
      version: APP_VERSION,
      build: BUILD_ID
    }
  }
}
</script>

<style scoped>
.panel-version { color: #6b7280; font-size: 0.75rem; }
</style>
